import { createSlice } from "@reduxjs/toolkit";

const specialistSlice = createSlice({
  name: "specialist",
  initialState: [],
  reducers: {
    specialistAdd(state, action) {
      return action.payload;
    },
    specialistSpecificAdd(state, action) {
      const specialist = action.payload;
      if (!action.payload) {
        return state;
      } else {
        const specialistIndex = state.findIndex(item => item.id === specialist.id);
        if (specialistIndex === -1) {
          return [...state, specialist];
        } else {
          state[specialistIndex] = specialist;
        }
      }
    },
    specialistCreate(state, action) {
      if (!action.payload) {
        return state;
      }
      state.push(action.payload);
    },
    specialistDelete(state, action) {
      const toDelete = state.findIndex(spec => spec.id === action.payload);
      if (toDelete > -1) state.splice(toDelete, 1);
    },
    specialistUpdate(state, action) {
      const updatedSpecialist = action.payload;
      const index = state.findIndex(spec => spec.id === updatedSpecialist.id);
      if (index !== -1) {
        state[index] = {
          ...state[index],
          ...updatedSpecialist,
        };
      }
    },
  },
});

export const {
  specialistAdd,
  specialistCreate,
  specialistDelete,
  specialistUpdate,
  specialistSpecificAdd,
} = specialistSlice.actions;
export default specialistSlice.reducer;
